import React from "react";
import { Box, Typography } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";

const NoPermission = ({
  message = "You don’t have permission to view this",
  maxh
   = "50vh"
}) => {
  return (
    <Box
      sx={{
        padding: 10,
        maxHeight: maxh,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "text.secondary",
        textAlign: "center"
      }}
    >
      <BlockIcon sx={{ fontSize: 48, mb: 1 }} color="disabled" />

      <Typography variant="h6" fontWeight={500}>
        {message}
      </Typography>
    </Box>
  );
};

export default NoPermission;
